// extracted by mini-css-extract-plugin
export default {"header":"webdev_header__5sOaS","main":"webdev_main__2TffH","title":"webdev_title__xUdTl","items":"webdev_items__gFFNS","item":"webdev_item__fCgZv"};